import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { UserPortalService } from '../../../shared/service/user-portal/user-portal.service';
import { UserApps,UserTypes } from '../../../shared/lib/model/common';
import { AppRoutes } from '../../../shared/lib/api-constant';
import { AuthService, CommonService, StorageService } from 'src/app/shared/service';

@Injectable({
  providedIn: 'root'
})
export class UserGuardGuard {
  constructor(
    private bdpAuthService: AuthService, private storageService: StorageService, private userService: UserPortalService, private commonService: CommonService) {
  }

  canActivate(
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userService.getUser().pipe(map((response: any) => {
      let userData = response.data;

      this.storageService.setItem('userData', userData);
      // Check App access
      let approvedApps: string[] = userData?.userApps?.map((app:any) => app.id.appCd);
      

      if (approvedApps?.length == 0 || !approvedApps?.includes(UserApps.DND)) {
        this.bdpAuthService.accessDeniedRedirect();
        return false;
      }
      else if(approvedApps?.length == 0 && !approvedApps?.includes(UserApps.DND_STAGE )){
        this.bdpAuthService.accessDeniedRedirect();
        return false;
      }
      else if (userData?.blockedYn == 'Y') { // Check user Blocked status
        this.bdpAuthService.accessDeniedRedirect();
        return false;
      }
      else if (userData?.activeYn == 'N') {
        this.bdpAuthService.reactivateRedirect();
        return false;
      }
      else return true;
    }), catchError((error) => {
      return of(false);
    }));
  }
  canActivateChild(
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = this.bdpAuthService.getUser();
    if (user && user.role == UserTypes.USER) {
      return true;
    } else {
      this.commonService.navigateRoute({
        route: AppRoutes.Auth.NOT_ASSOCIATED,
        type: 'User'
      });
      return false;
    }
  }
  canLoad(
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const user = this.bdpAuthService.getUser();
    if (user && user.role == UserTypes.USER) {
      return true;
    } else {
      this.commonService.navigateRoute({
        route: AppRoutes.Auth.NOT_ASSOCIATED,
        type: 'User'
      });
      return false;
    }
  }
}
